import styled from 'styled-components'
import { COLOR, FONT_SIZE, Z_INDEXS, SIDE_BAR } from '../../../themes'

export const StyleTopbar = styled.div`
  background: ${COLOR.WHITE};
  position: fixed;
  width: calc(100% - ${SIDE_BAR.WIDTH_SIZE});
  z-index: ${Z_INDEXS.LV_7};

  .top-bar__left {
    align-items: center;
    display: flex;
    margin-left: 43px;

    > .arrow__button {
      background-color: ${COLOR.WHITE};
      border: 0px solid transparent;
      cursor: pointer;
      padding: 0;
      &.left {
        margin-right: 27px;
      }
      &.right {
        margin-right: 21px;
      }
      > h1 {
        margin: 0 0 4px 0;
      }
    }

    button:active {
      background-color: transparent;
      color: ${({ colorTheme }) => colorTheme ? colorTheme : COLOR.GOLD_1};
    }

    button:focus {
      outline: none !important;
    }
    
    > .text-year, .text-month{
      align-self: center;
      font-size: ${FONT_SIZE.XS};
      font-family: NunitoSansBold;
    }
    > .text-month {
      margin-right: 8px;
    }
    > .text-year {
      margin-right: 40px;
    }
    
    > .box-today {
      padding-right: 22px;
      font-size: ${FONT_SIZE.XXS};
      font-family: NunitoSansRegular;
      white-space: nowrap;
      border-radius: 8px;
      border: 1px solid ${COLOR.GRAY_19};
      padding: 0 10px;
      min-height: 40px;
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-flow: row nowrap;
      margin-right: 24px;
    }
    > .box-today > *:first-child {
      margin-right: 8px;
    }
    
    > .box-view-selector {
      font-family: NunitoSansRegular;
      width: 120px;
    }
  }

  .css-g1d714-ValueContainer {
    padding: 2px 0 2px 8px;
  }
  .css-tlfecz-indicatorContainer,
  .css-1gtu0rj-indicatorContainer {
    color: ${COLOR.BLACK_1};
    padding: 8px 0;
    width: 18px;
  }
  .css-yk16xz-control {
    border-color: transparent;
  }
  .css-yk16xz-control:hover {
    border-color: ${COLOR.GOLD_1};
  }
  .css-1uccc91-singleValue {
    text-transform: capitalize;
  }
  .css-1okebmr-indicatorSeparator {
    background-color: transparent;
  }
  .css-2613qy-menu li{
    text-transform: capitalize;
  }
  .css-1hwfws3,
  .css-tlfecz-indicatorContainer{
    cursor: pointer;
  }
  .icon-calendar-dropdown-container {
    border-radius: 8px;
    border: 1px solid ${COLOR.GRAY_19};
    padding: 0 10px;
    min-width: 120px;
    min-height: 40px;
    box-sizing: border-box;
    cursor: pointer;
  }
  .icon-calendar-dropdown-singlevalue {
    text-align: right;
    margin: 0;
    width: 100%;
  }
  .icon-calendar-dropdown {
    stroke: #000;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 0.5px;
    font-size: 7px;
    font-family: NunitoSans-Bold, Nunito Sans;
    font-weight: 700;
  }
`
